document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll("[data-featured-collections]")
    .forEach((section) => {
      const tabs = section.querySelectorAll(".section__featured-collections--category-tab");
      const swiperEl = section.querySelector("swiper-component");
      const slides = section.querySelectorAll(".section__featured-collections .swiper-slide");

      function getSwiperInstance() {
        return swiperEl.swiper || swiperEl.swiperInstance || null;
      }

      function filterSlides(category) {
        slides.forEach((slide) => {
          if (slide.dataset.category === category) {
            slide.classList.remove("hidden-slide");
          } else {
            slide.classList.add("hidden-slide");
          }
        });

        const swiper = getSwiperInstance();
        if (swiper) {
          swiper.update();
          swiper.slideTo(0);
        }
      }

      const defaultTab = section.querySelector(
        ".section__featured-collections--category-tab[data-default-open]"
      );
      if (defaultTab) {
        filterSlides(defaultTab.dataset.category);
        defaultTab.classList.add("active");
      }

      tabs.forEach((tab) => {
        tab.addEventListener("click", () => {
          tabs.forEach((t) => t.classList.remove("active"));
          tab.classList.add("active");
          filterSlides(tab.dataset.category);
        });
      });
    });
});
